import React from 'react';
import Shoppingcart from '../components/Shoppingcart';
const Cart = () => {
    return (
        <div>
            <Shoppingcart />
        </div>
    );
}

export default Cart;
